const _ = require('lodash')

class TreeSelect {
  constructor(data = [], mode = 0) {
    this.data = data
    this.tableData = []
    this.selectedData = []
    this.colNum = 0
    this.mode = mode
    this.selectAll = false
    this.globalIndeterminate = false
    this.init()
  }

  // 筛选选中值以及伴选状态
  handleChange ({rowIdx, colIdx, selected}) {
    let rowSpan = this.tableData[rowIdx][colIdx].span,
        endIdx = rowIdx + rowSpan - 1

    // 筛选子级选中状态
    let _endIdx = endIdx
    while (_endIdx >= rowIdx) {
      let _colIdx = colIdx + 1
      while (_colIdx < this.colNum) {
        if (this.tableData[_endIdx][_colIdx]) {
          this.tableData[_endIdx][_colIdx].has = selected
          this.tableData[_endIdx][_colIdx].indeterminate = false
        }
        ++_colIdx
      }
      --_endIdx
    }

    // 筛选父级伴选状态
    let _colIdx = colIdx, _idx = rowIdx
    while (_colIdx > 0 && _idx >= 0) {
      if (this.tableData[_idx][--_colIdx]) {

        // 筛选其他平级菜单, 排除 全选 和 全不选，剩下就是 indeterminate
        let parent_col = this.tableData[_idx][_colIdx], // 父级菜单
            parent_span = parent_col.span, // 父级rowspan
            flag_arr = []

        let __colIdx = _colIdx + 1, __idx = _idx

        while (parent_span > 0) {
          if (this.tableData[__idx][__colIdx]) {
            flag_arr.push(this.tableData[__idx][__colIdx].has)
          }
          parent_span--
          __idx++
        }

        if (flag_arr.every(is_seclected => is_seclected)) {
          this.tableData[_idx][_colIdx].has = true
          this.tableData[_idx][_colIdx].indeterminate = false
        } else if (flag_arr.every(is_seclected => !is_seclected)) {
          if (this.mode === 0) {
            this.tableData[_idx][_colIdx].has = false
          }
          this.tableData[_idx][_colIdx].indeterminate = false
        } else {
          this.tableData[_idx][_colIdx].has = true
          this.tableData[_idx][_colIdx].indeterminate = true
        }
      } else {
        _idx--
        _colIdx++
      }
    }

    // 本身伴选状态
    this.tableData[rowIdx][colIdx].indeterminate = false

    this.filterSelected()
  }

  // 筛选已选col
  filterSelected () {

    // 遍历 tableData, 找出已选值
    let selectedData = [], selectAll = true
    this.tableData.forEach(perm => {
      Object.values(perm).forEach(val => {
        if (val.has) {
          selectedData.push(val.value)
        }

        if (selectAll) {
          selectAll = selectAll && val.has
        }
      })
    })
    this.selectedData = selectedData
    this.selectAll = selectAll
    this.globalIndeterminate = selectedData.length > 0 && !selectAll
  }

  // 筛选重复的表格数据
  tableDataFilter (data) {
    for (let len = data.length, i = len; i > 1;) {
      for (let key in data[--i]) {
        if ( _.isEqual( data[i][key], data[i-1][key] ) ) {
          delete data[i][key]
        }
      }
    }

    return data
  }

  // 表格数据遍历生成
  tableDataGenerate (data, rowItem = [], deep = 0, col = {}) {
    data.forEach(item => {
      col = { ...col, [deep]: {
          span: 0,
          value: item.name,
          text: item.displayName,
          has: item.has,
          index: deep
      }}
      
      if (item.children && item.children.length) {
        this.tableDataGenerate(item.children, rowItem, deep + 1, col)
      } else {
        let copy_deep = deep
        do {
          col[copy_deep].span += 1
        } while (copy_deep--)

        if (this.colNum < deep + 1) this.colNum = deep + 1
        rowItem.push( col )
      }
    })
    return rowItem
  }

  // 切换全选
  toggleAll (selected) {
    this.tableData.forEach(row => {
      for (let key in row) {
        if (row.hasOwnProperty(key)) {
          row[key].has = selected
          row[key].indeterminate = false
        }
      }
    })

    this.filterSelected()
  }

  init () {
    this.tableData = this.tableDataFilter(this.tableDataGenerate(this.data))
    this.filterSelected()
  }
}

export default TreeSelect